import moment from "moment";
import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postRoyalMailForm } from "../../redux/actions/royalMailActions";

const validateDDMMYYYY = (value) => {
  if (!value) return true;
  const date = moment(value, "DD/MM/YYYY", true);
  return date.isValid();
};

const validateTrue = (value) => !!value;

const FiveYearForm = ({ appData, postRoyalMailFormFunc }) => {
  const { firstName = "", lastName = "" } = appData;

  let initialData = {
    candidateName: `${firstName} ${lastName}`,
    date: moment().format("DD/MM/YYYY"),
    gapDeclaration: false,
  };

  if (appData.royalMailOnboarding && appData.royalMailOnboarding.fiveYearForm) {
    initialData = {
      ...initialData,
      ...appData.royalMailOnboarding.fiveYearForm,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";
  const getVal = getField(initialData);

  const initialState = {
    candidateName: {
      title: "Candidate name:",
      value: getVal("candidateName"),
      mandatory: true,
    },
    date: {
      title: "Date (dd/mm/yyyy):",
      value: getVal("date"),
      mandatory: true,
    },
    gapDeclaration: {
      title:
        "I declare that, should there be any gaps in my 5 year activity history, I was unemployed and I supported myself by one of the following; Savings, Pension, Redundancy payment, Family/Partner support, Loan, Government benefits*",
      type: "singlecheckbox",
      value: getVal("gapDeclaration"),
      validate: validateTrue,
    },
    postalQuestion: {
      title:
        "Have you ever worked in the postal industry in any country at any time?",
      type: "checkbox",
      value: getVal("postalQuestion"),
      mandatory: true,
    },
    postalFrom: {
      title: "From (dd/mm/yyyy):",
      value: getVal("postalFrom"),
      validate: validateDDMMYYYY,
      dependOn: [{ fieldKey: "postalQuestion" }],
    },
    postalTo: {
      title: "To (dd/mm/yyyy):",
      value: getVal("postalTo"),
      validate: validateDDMMYYYY,
      dependOn: [{ fieldKey: "postalQuestion" }],
    },
    postalName: {
      title: "Name of business/agency:",
      value: getVal("postalName"),
      dependOn: [{ fieldKey: "postalQuestion" }],
    },
    postalRole: {
      title: "Role held:",
      value: getVal("postalRole"),
      dependOn: [{ fieldKey: "postalQuestion" }],
    },
    postalReason: {
      title: "Reason for leaving:",
      value: getVal("postalReason"),
      dependOn: [{ fieldKey: "postalQuestion" }],
    },
    delimiter: {
      htmlObj: (
        <HorizontalLine
          text={"Activities"}
          desc={
            "For Royal Mail assignments the Agency needs to know in detail, what the candidate has been doing over the past 5 years"
          }
        />
      ),
    },
    activity1Delimiter: {
      htmlObj: <HorizontalLine text={"Activity 1"} />,
    },
    activity1From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity1From"),
    },
    activity1To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity1To"),
    },
    activity1Name: {
      title: "Name of business:",
      value: getVal("activity1Name"),
    },
    activity1RoleHeld: {
      title: "Role held:",
      value: getVal("activity1RoleHeld"),
    },
    activity1Reason: {
      title: "Reason for leaving:",
      value: getVal("activity1Reason"),
    },
    activity2Delimiter: { htmlObj: <HorizontalLine text={"Activity 2"} /> },
    activity2From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity2From"),
    },
    activity2To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity2To"),
    },
    activity2Name: {
      title: "Name of business:",
      value: getVal("activity2Name"),
    },
    activity2RoleHeld: {
      title: "Role held:",
      value: getVal("activity2RoleHeld"),
    },
    activity2Reason: {
      title: "Reason for leaving:",
      value: getVal("activity2Reason"),
    },
    activity3Delimiter: { htmlObj: <HorizontalLine text={"Activity 3"} /> },
    activity3From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity3From"),
    },
    activity3To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity3To"),
    },
    activity3Name: {
      title: "Name of business:",
      value: getVal("activity3Name"),
    },
    activity3RoleHeld: {
      title: "Role held:",
      value: getVal("activity3RoleHeld"),
    },
    activity3Reason: {
      title: "Reason for leaving:",
      value: getVal("activity3Reason"),
    },
    activity4Delimiter: { htmlObj: <HorizontalLine text={"Activity 4"} /> },
    activity4From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity4From"),
    },
    activity4To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity4To"),
    },
    activity4Name: {
      title: "Name of business:",
      value: getVal("activity4Name"),
    },
    activity4RoleHeld: {
      title: "Role held:",
      value: getVal("activity4RoleHeld"),
    },
    activity4Reason: {
      title: "Reason for leaving:",
      value: getVal("activity4Reason"),
    },
    activity5Delimiter: { htmlObj: <HorizontalLine text={"Activity 5"} /> },
    activity5From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity5From"),
    },
    activity5To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity5To"),
    },
    activity5Name: {
      title: "Name of business:",
      value: getVal("activity5Name"),
    },
    activity5RoleHeld: {
      title: "Role held:",
      value: getVal("activity5RoleHeld"),
    },
    activity5Reason: {
      title: "Reason for leaving:",
      value: getVal("activity5Reason"),
    },
    activity6Delimiter: { htmlObj: <HorizontalLine text={"Activity 6"} /> },
    activity6From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity6From"),
    },
    activity6To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity6To"),
    },
    activity6Name: {
      title: "Name of business:",
      value: getVal("activity6Name"),
    },
    activity6RoleHeld: {
      title: "Role held:",
      value: getVal("activity6RoleHeld"),
    },
    activity6Reason: {
      title: "Reason for leaving:",
      value: getVal("activity6Reason"),
    },
    activity7Delimiter: { htmlObj: <HorizontalLine text={"Activity 7"} /> },
    activity7From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity7From"),
    },
    activity7To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity7To"),
    },
    activity7Name: {
      title: "Name of business:",
      value: getVal("activity7Name"),
    },
    activity7RoleHeld: {
      title: "Role held:",
      value: getVal("activity7RoleHeld"),
    },
    activity7Reason: {
      title: "Reason for leaving:",
      value: getVal("activity7Reason"),
    },
    activity8Delimiter: { htmlObj: <HorizontalLine text={"Activity 8"} /> },
    activity8From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity8From"),
    },
    activity8To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity8To"),
    },
    activity8Name: {
      title: "Name of business:",
      value: getVal("activity8Name"),
    },
    activity8RoleHeld: {
      title: "Role held:",
      value: getVal("activity8RoleHeld"),
    },
    activity8Reason: {
      title: "Reason for leaving:",
      value: getVal("activity8Reason"),
    },
    activity9Delimiter: { htmlObj: <HorizontalLine text={"Activity 9"} /> },
    activity9From: {
      title: "From (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity9From"),
    },
    activity9To: {
      title: "To (dd/mm/yyyy):",
      validate: validateDDMMYYYY,
      value: getVal("activity9To"),
    },
    activity9Name: {
      title: "Name of business:",
      value: getVal("activity9Name"),
    },
    activity9RoleHeld: {
      title: "Role held:",
      value: getVal("activity9RoleHeld"),
    },
    activity9Reason: {
      title: "Reason for leaving:",
      value: getVal("activity9Reason"),
    },
    safetyDelimiter: {
      htmlObj: <HorizontalLine text={"Personal Protective Equipment(PPE)"} />,
    },
    safetyFootwear: {
      title:
        "Do you have your own safety footwear that you are willing to use for this role?",
      type: "checkbox",
      value: getVal("safetyFootwear"),
      mandatory: true,
    },
    safetyVest: {
      title:
        "Do you have your own high visibility vest that you are willing to use for this role?",
      type: "checkbox",
      value: getVal("safetyVest"),
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postRoyalMailFormFunc("fiveYearForm", formCreatorConvertToValues(fields));
    history.push("/profile/edit/royal-mail-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Royal Mail 5 Year Interview"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
    />
  );
};

FiveYearForm.propTypes = {
  appData: any,
  postRoyalMailFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postRoyalMailFormFunc: postRoyalMailForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(FiveYearForm);
